import HomeProductCard from "./HomeProductCard";
import "./HomeProductSection.css";
import { Button } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useState, useEffect, useRef } from "react";
import { findProducts } from "../../../Redux/Customers/Product/Action";
import { useDispatch, useSelector } from "react-redux";
import AliceCarousel from "react-alice-carousel";
import { TruckRemoveOutline } from "mdi-material-ui";

const HomeProductSection = ({ section, query, view_all }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const slidePrev = () => setActiveIndex(activeIndex - 4);
  const slideNext = () => setActiveIndex(activeIndex + 4);
  const dispatch = useDispatch();
  const { customersProduct } = useSelector((store) => store);
  const store = useSelector((store) => store);
  const [products, setProducts] = useState([]);
  const carouselRef = useRef(null);

  const syncActiveIndex = ({ item }) => setActiveIndex(item);
  const handlePrevClick = () => {
    if (carouselRef.current) {
      carouselRef.current.slidePrev();
    }
  };

  const handleNextClick = () => {
    if (carouselRef.current) {
      carouselRef.current.slideNext();
    }
  };

  useEffect(() => {
    const data = {
      category: `${query}`,
      colors: [],
      sizes: [],
      minPrice: 0,
      maxPrice: 10000,
      minDiscount: 0,
      sort: "price_low",
      pageNumber: 1,
      pageSize: 10,
      stock: null,
      view_all,
    };
    dispatch(findProducts(data));
  }, [query]);

  useEffect(() => {
    setProducts(customersProduct.products);
  }, [customersProduct]);


  const responsive = {
    0: {
      items: 2,
      itemsFit: "contain",
    },
    568: {
      items: 3,
      itemsFit: "contain",
    },
    1024: {
      items: 5.5,
      itemsFit: "contain",
    },
  };

  // const items = products?.slice(0, 10).map((item) => (
  //   <div className="">
  //     <HomeProductCard product={item} />
  //   </div>
  // ));

  return (
    <div className="relative px-4 lg:ml-11 lg:mr-11 sm:px-6 lg:px-8">
      <h2 className="text-2xl font-extrabold mt-12 mb-3 text-center text-[#b28585]">
        {section}
      </h2>
      <div className="relative p-5">
        <AliceCarousel
          disableButtonsControls
          disableDotsControls
          mouseTracking
          items={
            products[`${query}`]?.content?.length
              ? products[`${query}`]?.content?.slice(0, 10).map((item) => (
                  <div className="">
                    <HomeProductCard product={item} category={query} view_all />
                  </div>
                ))
              : []
          }
          activeIndex={activeIndex}
          responsive={responsive}
          onSlideChanged={syncActiveIndex}
          animationType="fadeout"
          animationDuration={250}
          ref={carouselRef}
        />
        <div className="hidden lg:inline">
          {activeIndex !== products[`${query}`]?.content?.length - 5 &&
            products[`${query}`]?.content?.length > 5 && (
              <ArrowForwardIosIcon
                onClick={handleNextClick}
                sx={{
                  position: "absolute",
                  top: "11rem",
                  right: "0rem",
                  transform: "translateX(50%) rotate(0deg)",
                  cursor: "pointer",
                }}
              />
            )}

          {activeIndex !== 0 && (
            <ArrowForwardIosIcon
              className=""
              sx={{
                position: "absolute",
                top: "11rem",
                left: "0rem",
                transform: "translateX(-50%)  rotate(180deg)",
                cursor: "pointer",
              }}
              onClick={handlePrevClick}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default HomeProductSection;
